import { NavLink } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { BrupaLogo } from "@/components/BrupaLogo";

export function Footer() {
  return (
    <>
      {/* Perks strip — sopra il footer scuro */}
      <div className="bg-white border-t border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { title: "Spedizione gratuita", sub: "Per ordini da €150 in tutta Europa" },
              { title: "Resi entro 14 giorni", sub: "Rimborso al costo fisso di €7" },
              { title: "Pagamenti sicuri", sub: "Tutte le transazioni protette al 100%" },
              { title: "Supporto WhatsApp", sub: "Siamo sempre pronti ad aiutarti" },
            ].map(({ title, sub }) => (
              <div key={title}>
                <p className="text-stone-900 font-semibold tracking-widest uppercase text-[10px]">{title}</p>
                <p className="text-stone-400 text-xs mt-1">{sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <footer className="bg-stone-900 text-stone-400">
      {/* Top section */}
      <div className="border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
            {/* Brand */}
            <div className="md:col-span-2">
              <BrupaLogo color="#ffffff" height={34} />
              <p className="mt-4 text-sm text-stone-400 leading-relaxed max-w-xs">
                Brupa è il tuo fashion mall online. Un'unica destinazione dove trovi abbigliamento, scarpe e accessori dei migliori brand a prezzi outlet.
              </p>
              <div className="mt-6 flex gap-4">
                <a href="https://www.instagram.com/brupa.it" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-stone-500 hover:text-emerald-400 transition-colors">
                  <Instagram className="size-5" />
                </a>
                <a href="https://www.facebook.com/brupa.it" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-stone-500 hover:text-emerald-400 transition-colors">
                  <Facebook className="size-5" />
                </a>
              </div>
            </div>

            {/* Collezioni */}
            <div>
              <h4 className="text-[10px] tracking-[0.25em] uppercase text-stone-300 font-semibold mb-5">Collezioni</h4>
              <ul className="space-y-3 text-sm">
                {[
                  { to: "/donna", label: "Donna" },
                  { to: "/uomo", label: "Uomo" },
                  { to: "/shop?cat=accessori", label: "Accessori" },
                  { to: "/shop?cat=scarpe", label: "Scarpe" },
                  { to: "/shop?badge=SALE", label: "Saldi" },
                ].map((l) => (
                  <li key={l.to}>
                    <NavLink to={l.to} className="hover:text-emerald-400 transition-colors">
                      {l.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Azienda */}
            <div>
              <h4 className="text-[10px] tracking-[0.25em] uppercase text-stone-300 font-semibold mb-5">Azienda</h4>
              <ul className="space-y-3 text-sm">
                {[
                  { to: "/about", label: "Chi siamo" },
                  { to: "/about", label: "Perché Brupa" },
                  { to: "/about", label: "Spedizioni" },
                  { to: "/about", label: "Resi" },
                  { to: "/about", label: "Pagamenti" },
                ].map((l) => (
                  <li key={l.label}>
                    <NavLink to={l.to} className="hover:text-emerald-400 transition-colors">
                      {l.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="text-[10px] tracking-[0.25em] uppercase text-emerald-400 font-semibold mb-5">Newsletter</h4>
              <p className="text-sm mb-1 font-semibold text-white">10% di sconto subito!</p>
              <p className="text-sm text-stone-400 mb-4 leading-relaxed">
                Iscriviti e ricevi offerte esclusive, nuovi arrivi e consigli di stile.
              </p>
              <form onSubmit={(e) => e.preventDefault()} className="flex flex-col gap-3">
                <input
                  type="email"
                  placeholder="La tua email"
                  className="bg-stone-800 border border-stone-700 text-stone-200 text-sm px-4 py-3 focus:outline-none focus:border-emerald-400 placeholder-stone-500 transition-colors"
                />
                <button
                  type="submit"
                  className="bg-emerald-500 text-white text-[10px] tracking-widest uppercase font-semibold py-3 hover:bg-emerald-600 transition-colors"
                >
                  Iscriviti
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-600">
        <p>&copy; {new Date().getFullYear()} Brupa Fashion Mall — Tutti i diritti riservati.</p>
        <div className="flex gap-5">
          <a href="#" className="hover:text-emerald-400 transition-colors">Informativa sulla Privacy</a>
          <a href="#" className="hover:text-emerald-400 transition-colors">Cookie Policy</a>
          <a href="#" className="hover:text-emerald-400 transition-colors">Termini e Condizioni</a>
        </div>
      </div>
    </footer>
    </>
  );
}
